import { Icon } from '@components/index';
import { formatISODate } from '@utils/date';

import { LeadType } from '../types/common';
import { formatMobileNumber } from '../utils/common';

interface LeadInformationProps {
  handleEditContact: () => void;
  leadData: LeadType;
}

const LeadInformation = ({
  handleEditContact,
  leadData
}: LeadInformationProps) => {
  const contactInfo = [
    {
      icon: 'phone',
      label: 'Mobile Number',
      value: formatMobileNumber(
        leadData?.mobile_number,
        leadData?.country_code
      ),
      hasWhatsApp: true
    },
    {
      icon: 'phone',
      label: 'Alternate Number',
      value: leadData?.secondary_mobile_number
        ? formatMobileNumber(
            leadData?.secondary_mobile_number,
            leadData?.secondary_country_code
          )
        : '',
      hasWhatsApp: false
    },
    {
      icon: 'mail',
      label: 'Email ID',
      value: leadData?.email_id
    }
  ];

  const moreInfo = [
    {
      icon: 'location',
      label: 'Location',
      value:
        leadData?.city || leadData?.state
          ? `${leadData?.city || ''}${
              leadData?.city && leadData?.state ? ', ' : ''
            }${leadData?.state || ''}`.trim()
          : ''
    },
    {
      icon: 'clock',
      label: 'Created Time',
      value: leadData?.created_at
        ? formatISODate({
            date: leadData.created_at,
            format: 'DD MMM YYYY hh:mm am/pm'
          })
        : ''
    },
    {
      icon: 'ruppee-circle',
      label: 'Deal Value',
      value: (
        <>
          <span className="font-inter">₹ </span>
          {((leadData?.deal_value ?? 0) / 100)?.toLocaleString()}
        </>
      )
    },
    {
      icon: 'category-icon',
      label: 'Lead Category',
      value: leadData?.category?.value
    },
    {
      icon: 'source-icon',
      label: 'Source',
      value: leadData?.source
    },
    {
      icon: 'open-book',
      label: 'Description',
      value: leadData?.description
    }
  ];

  return (
    <div className="flex h-[856px] w-[347px] flex-col gap-4">
      <div className="rounded-xl bg-white p-6 shadow-sm">
        <div className="flex flex-row justify-between">
          <h2 className="mb-2 text-18 font-semibold text-content">
            Lead Details
          </h2>
          <Icon
            name="edit-grey"
            size="medium"
            className="cursor-pointer text-gray-600 hover:text-gray-800"
            style={{ width: '24px', height: '24px' }}
            onClick={handleEditContact}
          />
        </div>

        <h2 className="mb-4 text-base font-semibold text-gray-900">
          Contact Information
        </h2>
        <div className="space-y-4">
          {contactInfo.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="flex gap-3">
                <div className="flex size-8 items-center justify-center rounded-full bg-gray-100">
                  <Icon
                    name={item.icon}
                    size="small"
                    className="text-gray-600"
                    style={{ width: '18px', height: '18px' }}
                  />
                </div>
                <div className="flex flex-col gap-0.5">
                  <span className="text-sm font-medium text-grey">
                    {item.label}
                  </span>
                  <span className="text-base font-medium text-content">
                    {item?.value ? item?.value : '--'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <h2 className="my-4 text-base font-semibold text-gray-900">
          More Info
        </h2>
        <div className="space-y-4">
          {moreInfo.map((item) => (
            <div key={`${item.icon}-${item.label}`} className="flex gap-3">
              <div className="flex size-10 min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-gray-100">
                <Icon
                  name={item.icon}
                  size="medium"
                  className="text-gray-600"
                />
              </div>
              <div className="flex flex-col gap-0.5">
                <span className="text-sm font-medium text-grey">
                  {item.label}
                </span>
                <span className="text-base font-medium text-content">
                  {item?.value ? item?.value : '--'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadInformation;
